/* tslint:disable */

/**
 */
export class MembershipInput {
    key_case?: string;
    key_input?: any;
    key_search?: string;
}
